module.exports = __webpack_public_path__ + "arrow-back@2x.png?0484fbcc5d949df3f12706d92a5d87f9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-back@2x.png
// module id = 21
// module chunks = 0